/*global BMS*/
import chipsConfig from './configurations/chipsConfig.json';
import {BET_LIMITS} from './betLimits';
import {OPERATOR} from './operator';

export const BASE_VALUE = 100;
export const CHIPS = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? chipsConfig.chips.filter((chip) => (chip.multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] >= BET_LIMITS.minStake) && (chip.multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] <= BET_LIMITS.maxStake))
    : BMS
        ? BMS.chips.filter((chip) => chip.multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] >= BET_LIMITS.minStake)
        : {};

// used with the multipliers

export function getChipValue(chipIndex) {
    if (Number.isInteger(chipIndex)) {
        return CHIPS[chipIndex].multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency];
    }
    return 0;
}

export function getHumanReadableChipValue(chipIndex) {
    let val = getChipValue(chipIndex);
    return val
        ? val / 100
        : 0;
}

export function getChipByValue(value) {
    for (let i = 0; i < CHIPS.length; i++) {
        if (CHIPS[i].multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] === value) {
            return CHIPS[i];
        }
    }
}

export function getClosestChipByValue(value) {
    for (let i = 0; i < CHIPS.length; i++) {
        if ((i === 0 && CHIPS[i].multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] >= value) || (i < CHIPS.length - 1 && CHIPS[i].multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency] <= value && value < CHIPS[i + 1].multiplier * BASE_VALUE * JSON.parse(OPERATOR.currencyMultipliers)[OPERATOR.currency]) || (i === CHIPS.length - 1)) {
            return CHIPS[i];
        }
    }
}



// WEBPACK FOOTER //
// ./src/constants/chips.js